import { useTranslation } from "react-i18next";
import { useQuery } from 'react-query';
// import cn from "classnames";
import { AddSellerPanel } from "@components/AddSeller";
import { Column } from "@components/Grid";
import Box from "@components/Box";
import { Text, TextSize, TextType, TextWeight } from '@components/Text';
import LevelItem from "../components/LevelItem";
import { getUniClubLevels } from '@api/apiClient/club';
import styles from "./Tab.module.scss";

const CashbackTab = ({
  sellersNotFound,
  onUpdate,
}: {
  sellersNotFound: boolean,
  onUpdate: () => void,
}) => {
  const { t } = useTranslation();

  const { data } = useQuery({
    queryKey: ["getUniClubLevels"],
    queryFn: getUniClubLevels,
    retry: 1,
    select: (data) => ({
      ...data,
      levels: data.levels.map((item, idx) => ({
        ...item,
        name: item.name.toLowerCase(),
        nextLevelFrom: data.levels[idx + 1]?.spentFrom,
        cashbackPercent: item.cashbackPercent * 100,
      })),
    }),
    enabled: !sellersNotFound,
  });

  return (
    <div>
      {sellersNotFound ? (
        <AddSellerPanel onSuccess={onUpdate} isFirstSeller />
      ) : (
        <>
          <Box pb={5}>
            <Column phone={12}>
              <Text
                size={TextSize.M}
                type={TextType.BLOCK}
                dangerouslySetInnerHTML={{
                  __html: t('uniClub.cashbackTab.description')
                }}
                maxWidth="580px"
              />
            </Column>
          </Box>
          <Box pb={5}>
            <Text size={TextSize.L} weight={TextWeight.BOLD}>
              {t('uniClub.cashbackTab.cashbackLevel')}
            </Text>
          </Box>

          <div className={styles.levels}>
            {(data?.levels || []).map(level => (
              <LevelItem
                data={level}
                currentCashback={data?.currentCashback}
                currentSpend={data?.currentSpend}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default CashbackTab;
